import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ShopPlugin } from '@pdqdev/pdq-shared/dist/interfaces';

@Component({
  selector: 'product-page-settings-tab',
  templateUrl: './product-page-settings-tab.component.html',
  styleUrls: ['./product-page-settings-tab.component.scss'],
  standalone: false,
})
export class ProductPageSettingsTabComponent {
  @Input() formGroup: UntypedFormGroup;
  @Input() pluginType: ShopPlugin.ProductPagePromise.PluginType;

  LayoutMode = ShopPlugin.ProductPagePromise.LayoutMode;

  get isProService(): boolean {
    return this.pluginType === ShopPlugin.ProductPagePromise.PluginType.PRO_SERVICE;
  }

  get isBasicSelected(): boolean {
    return this.formGroup.get('layoutMode')?.value === ShopPlugin.ProductPagePromise.LayoutMode.BASIC;
  }

  get isAdvancedSelected(): boolean {
    return this.formGroup.get('layoutMode')?.value === ShopPlugin.ProductPagePromise.LayoutMode.ADVANCED;
  }

  selectLayoutMode(mode: ShopPlugin.ProductPagePromise.LayoutMode): void {
    this.formGroup.get('layoutMode')?.setValue(mode);
    this.formGroup.get('layoutMode')?.markAsDirty();
  }
}
